// extracted by mini-css-extract-plugin
export default {"timelineCard__container":"TimelineCard_timelineCard__container__Xk2yp"};